<template>
  <!-- <div class="layout"> -->
    <v-layout full-height="true">
      <AppDrawer />
      <v-main>
        <slot></slot>
      </v-main>
      <AppAdminNav />
      <!-- <AppFooter /> -->
    </v-layout>
  <!-- </div>/ -->
</template>

<script>
import AppAdminNav from "./AppAdminNav";
import AppDrawer from "./AppDrawer";
// import AppFooter from "./AppFooter";
export default {
  components: {
    AppAdminNav,
    // AppFooter,
    AppDrawer,
  },
  data: () => ({
    drawer: false,
  }),
};
</script>
